export default __webpack_public_path__ + "static/media/02.19f5ecad.jpg";